import { Card, FormHelperText, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  getAllClinicPaymentOfHugeRecord,
  getClinicUsers,
  getSupplier,
} from "../../../redux/reducers/clinicSlice";
import { updateReturnOnBillingItems } from "../../../redux/reducers/paymentSlice";
import { AppColors } from "../../../util/AppColors";
import { ReturnAdjustList } from "../../../util/arrayList";
import { RefundTypes, returnReasons } from "../../../util/dropList";
import {
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getRefundValues,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
  roundWithSignedDiff,
} from "../../../util/function";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";

const initModValues = {
  type: null,
  customer: null,
  supplier: null,
  searchValue: "",
};

const PaymentReturn = ({
  returnModVisible,
  onReturnModClose = () => {},
  headerName = "Stock Adjustment",
}) => {
  const dispatch = useDispatch();
  const [modVsble, setModVsble] = useState(false);
  const [modValues, setModValues] = useState(initModValues);
  const [modErrors, setModErrors] = useState({});
  const [selectedBill, setSelectedBill] = useState(null);
  const [returnValue, setReturnValue] = useState({});
  const [listNotValid, setListNotValid] = useState(false);
  const [updateModVsble, setUpdateModVsble] = useState(false);
  const { suppliers, users, hugePayments } = useSelector(
    (state) => state?.clinic,
  );
  // const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { vets: clinicVets } = useMemo(() => {
    if (!mandateDataRaw) {
      return { vets: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
      };
    } catch {
      return { vets: [] };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    setModVsble(returnModVisible);
    setModValues(initModValues);
    setSelectedBill(null);
    setModErrors({});
  }, [returnModVisible]);

  useEffect(() => {
    if (
      modValues?.searchValue?.length > 2 &&
      modValues?.type?.value === "Return on Sales"
    ) {
      dispatch(
        getClinicUsers(`?search=${modValues?.searchValue}&itemSize=50&page=1`),
      );
    }
    if (
      modValues?.searchValue?.length > 2 &&
      modValues?.type?.value === "Return on Purchase"
    ) {
      dispatch(
        getSupplier(`?search=${modValues?.searchValue}&itemSize=50&page=1`),
      );
    }
  }, [modValues?.searchValue]);

  const onCloseRetMod = (typ = null) => {
    setUpdateModVsble(false);
    setModVsble(false);
    onReturnModClose(typ);
  };

  const handleSelectedUser = (user) => {
    const createObj = {
      ...modValues,
      customer: { name: user?.name, value: user?.id },
      searchValue: "",
    };
    setModErrors({ ...modErrors, customer: "" });
    dispatch(
      getAllClinicPaymentOfHugeRecord(
        `?filter=all&type=all&page=1&itemSize=10&userId=${user?.id}`,
      ),
    )?.then((res) => {
      if (res?.payload) {
        const matchedPayment = res?.payload?.data?.find(
          (li) =>
            li?.invoiceNumbers?.length > 0 ||
            li?.treatmentInvoiceNumber?.length > 0 ||
            li?.petShopInvoiceNumber?.length > 0,
        );
        const reqList =
          matchedPayment?.treatmentInvoiceNumber?.length > 0
            ? getTreatmentRecordBasedType(matchedPayment?.paymentDetails)
            : matchedPayment?.invoiceNumbers?.length > 0
              ? getPharmacyRecordBasedType(matchedPayment?.paymentDetails)
              : matchedPayment?.petShopInvoiceNumber?.length > 0
                ? getPetShopRecordBasedType(matchedPayment?.paymentDetails)
                : [];
        const reqAmtData = roundWithSignedDiff(
          getTaxAndSubTotalAndTotal(reqList)?.total,
        );
        const reqInObj = {
          name: `${matchedPayment?.treatmentInvoiceNumber?.length > 0 ? matchedPayment?.treatmentInvoiceNumber : matchedPayment?.invoiceNumbers?.length > 0 ? matchedPayment?.invoiceNumbers : matchedPayment?.petShopInvoiceNumber?.length > 0 ? matchedPayment?.petShopInvoiceNumber : ""}, ₹${reqAmtData?.rounded}, ${moment(new Date(matchedPayment?.createdDate)).format("DD MMM YYYY")}`,
          value:
            matchedPayment?.treatmentInvoiceNumber?.length > 0
              ? matchedPayment?.treatmentInvoiceNumber
              : matchedPayment?.invoiceNumbers?.length > 0
                ? matchedPayment?.invoiceNumbers
                : matchedPayment?.petShopInvoiceNumber?.length > 0
                  ? matchedPayment?.petShopInvoiceNumber
                  : "",
          paymentId: matchedPayment?.paymentId,
        };
        createObj.invoiceNumber = reqInObj;
      }
      setModValues(createObj);
    });
  };

  const handleSelectedSupplier = (sup) => {
    const reqObj = {
      ...modValues,
      supplier: { name: sup?.supplierName, value: sup?.supplierId },
      searchValue: "",
    };
    const reqDet =
      sup?.supplierDetails?.find(
        (li) => li?.subpplierInvoiceDetails?.length > 0,
      ) ?? sup?.supplierDetails?.[0];
    const reqList = (reqDet?.subpplierInvoiceDetails ?? [])?.map((sd) => ({
      tax: sd?.taxes ?? 0,
      total: sd?.itemTotal ?? 0,
    }));
    const reqAmtData = roundWithSignedDiff(
      getTaxAndSubTotalAndTotal(reqList)?.total,
    );
    if (reqDet) {
      reqObj.invoiceNumber = {
        name: `${reqDet?.invoiceNumber ?? ""}, ₹${reqAmtData?.rounded}, ${moment(new Date(reqDet?.billDate)).format("DD MMM YYYY")}`,
        value: reqDet?.invoiceNumber ?? "",
        detailId: reqDet?.detailId,
        supplierId: sup?.supplierId,
      };
    } else {
      reqDet.invoiceNumber = null;
    }
    setModValues(reqObj);
    setModErrors({ ...modErrors, supplier: "" });
  };

  const onChangeModValue = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqObj = { ...modValues, [name]: value };
    if (name === "type") reqObj.invoiceNumber = null;
    setModValues(reqObj);
    const errs = {
      ...modErrors,
      [name]:
        (typeof reqValue === "number" ? reqValue?.toString() : reqValue)
          ?.length > 0
          ? ""
          : "This field is required",
    };
    setModErrors(errs);
  };

  const getFilteredSupplierList = () => {
    const reqList = suppliers?.data?.filter((usr) => {
      if (
        usr?.supplierName
          ?.toLowerCase()
          .includes(modValues?.searchValue?.toLowerCase())
      ) {
        return usr;
      }
    });
    return reqList ?? [];
  };

  const getFilteredUserList = () => {
    const reqList = users?.filter((usr) => {
      if (
        usr?.name
          ?.toLowerCase()
          .includes(modValues?.searchValue?.toLowerCase()) ||
        usr?.email
          ?.toLowerCase()
          .includes(modValues?.searchValue?.toLowerCase()) ||
        usr?.mobile
          ?.toLowerCase()
          .includes(modValues?.searchValue?.toLowerCase())
      ) {
        return usr;
      }
    });
    return reqList ?? [];
  };

  const getSupInvoiceList = () => {
    if (!modValues?.supplier?.value) return [];
    return (suppliers?.data ?? [])
      ?.find((sup) => sup?.supplierId === modValues?.supplier?.value)
      ?.supplierDetails?.map((det) => {
        const reqList = (det?.subpplierInvoiceDetails ?? [])?.map((sd) => ({
          tax: sd?.taxes ?? 0,
          total: sd?.itemTotal ?? 0,
        }));
        const reqAmtData = roundWithSignedDiff(
          getTaxAndSubTotalAndTotal(reqList)?.total,
        );
        return {
          name: `${det?.invoiceNumber ?? ""}, ₹${reqAmtData?.rounded}, ${moment(new Date(det?.billDate)).format("DD MMM YYYY")}`,
          value: det?.invoiceNumber ?? "",
          detailId: det?.detailId,
          supplierId: modValues?.supplier?.value,
        };
      });
  };

  const getInvoiceList = () => {
    const reqList = (hugePayments?.data ?? [])
      ?.flatMap((li) => [
        li?.invoiceNumbers,
        li?.treatmentInvoiceNumber,
        li?.petShopInvoiceNumber,
      ])
      ?.filter(Boolean);
    return reqList?.map((li) => {
      const reqBill = (hugePayments?.data ?? [])?.find(
        (pl) =>
          pl?.invoiceNumbers === li ||
          pl?.treatmentInvoiceNumber === li ||
          pl?.petShopInvoiceNumber === li,
      );
      const reqList = li?.includes("INVC")
        ? getTreatmentRecordBasedType(reqBill?.paymentDetails)
        : li?.includes("INVP")
          ? getPharmacyRecordBasedType(reqBill?.paymentDetails)
          : li?.includes("INVS")
            ? getPetShopRecordBasedType(reqBill?.paymentDetails)
            : [];
      const reqAmtData = roundWithSignedDiff(
        getTaxAndSubTotalAndTotal(reqList)?.total,
      );
      return {
        name: `${li}, ₹${reqAmtData?.rounded}, ${moment(new Date(reqBill?.createdDate)).format("DD MMM YYYY")}`,
        value: li,
        paymentId: reqBill?.paymentId,
      };
    });
  };

  const handleSubmit = () => {
    let errs = {};
    if (!modValues?.type?.value) {
      errs.type = "This field is required";
    }
    if (
      modValues?.type?.value === "Return on Sales" &&
      !modValues?.customer?.value
    ) {
      errs.customer = "This field is required";
    }
    if (
      modValues?.type?.value === "Return on Purchase" &&
      !modValues?.supplier?.value
    ) {
      errs.supplier = "This field is required";
    }
    if (!modValues?.invoiceNumber?.value) {
      errs.invoiceNumber = "This field is required";
    }
    if (Object.keys(errs)?.length > 0) return setModErrors(errs);
    if (modValues?.type?.value === "Return on Purchase") {
      const reqBill = (suppliers?.data ?? [])?.find(
        (pay) => pay?.supplierId === modValues?.invoiceNumber?.supplierId,
      );
      const reqSupDet = reqBill?.supplierDetails?.find(
        (suDe) => suDe?.detailId === modValues?.invoiceNumber?.detailId,
      );
      const reqTableList = reqSupDet?.supplierInvoiceDetails?.map((sil) => {
        const mrpPrice =
          Number(sil?.itemTotal ?? 0) / Number(sil?.quantity ?? 0);
        return {
          ...sil,
          returnQuantity: 0,
          name: sil?.tradeName,
          mrpPrice,
          tax: sil?.taxes ?? 0,
          price: mrpPrice ?? 0,
        };
      });
      const returnObj = {
        refundMethod: {
          name: "Advance Adjustment",
          value: "Advance Adjustment",
        },
        remarks: reqBill?.remarks ?? "",
        returnReason: returnReasons?.[0],
        personInCharge: null,
        invoiceNumber: modValues?.invoiceNumber,
        list: reqTableList,
        type: modValues?.type?.value,
      };
      setSelectedBill({
        ...reqBill,
        createdDate: reqSupDet?.billDate,
        invoiceNumbers: reqSupDet?.invoiceNumber,
      });
      setReturnValue(returnObj);
      setUpdateModVsble(true);
      //   return onCloseRetMod("close");
    }
    if (modValues?.type?.value === "Return on Sales") {
      const reqBill = (hugePayments?.data ?? [])?.find(
        (pay) => pay?.paymentId === modValues?.invoiceNumber?.paymentId,
      );
      const returnObj = {
        refundMethod: {
          name: "Advance Adjustment",
          value: "Advance Adjustment",
        },
        remarks: reqBill?.remarks ?? "",
        returnReason: returnReasons?.[0],
        personInCharge: null,
        invoiceNumber: modValues?.invoiceNumber,
        type: modValues?.type?.value,
      };
      const reqList = modValues?.invoiceNumber?.value?.includes("INVC")
        ? getTreatmentRecordBasedType(reqBill?.paymentDetails)
        : modValues?.invoiceNumber?.value?.includes("INVP")
          ? getPharmacyRecordBasedType(reqBill?.paymentDetails)
          : modValues?.invoiceNumber?.value?.includes("INVS")
            ? getPetShopRecordBasedType(reqBill?.paymentDetails)
            : [];
      returnObj.list = reqList
        ?.filter(
          (li) =>
            li?.credit === "N" &&
            li?.type?.toLowerCase() !== "consumables" &&
            li?.type?.toLowerCase() !== "administered" &&
            li?.quantity > 0 &&
            (li?.returnQuantity === 0 || !li?.returnQuantity),
        )
        ?.map((li) => ({ ...li, returnQuantity: 0 }));
      setSelectedBill(reqBill);
      setReturnValue(returnObj);
      setUpdateModVsble(true);
      //   return onCloseRetMod("close");
    }
  };

  const submitReturn = (status = "") => {
    const returnList = returnValue?.list;
    if (returnList?.length === 0 || !returnList) return setListNotValid(true);
    const paymentDetails = returnList?.map((li, i) => {
      const unitPrice = isNaN(
        Number(Number(li?.total ?? li?.itemTotal) / Number(li?.quantity)),
      )
        ? 0
        : Number(Number(li?.total ?? li?.itemTotal) / Number(li?.quantity));
      const unitTax = isNaN(Number(Number(li?.tax) / Number(li?.quantity)))
        ? 0
        : Number(Number(li?.tax) / Number(li?.quantity));
      let reqbj = {
        unitPrice,
        unitTax,
        quantity: li?.quantity ?? 0,
        tax: Number(Number(unitTax ?? 0) * Number(li?.returnQuantity ?? 0)),
        price: li?.price,
        total: Number(Number(unitPrice ?? 0) * Number(li?.returnQuantity ?? 0)),
        returnQuantity: Number(li?.returnQuantity),
        name: li?.name,
        paymentDetailId: li?.paymentDetailId ?? null,
        stockId: li?.stockId ?? null,
        batchId: li?.batchId ?? null,
      };
      // if (returnValue?.type !== "Return on Purchase") {
      //   reqbj.tax = li?.tax;
      //   reqbj.price = li?.price;
      //   reqbj.total = li?.total;
      // }
      // if (returnValue?.type === "Return on Purchase") {
      //   reqbj = {
      //     ...reqbj,
      //     ...(li ?? {}),
      //     returnQuantity: Number(li?.returnQuantity),
      //   };
      //   reqbj.tax = Number(li?.tax ?? 0 / li?.quantity ?? 0)?.toFixed(2);
      //   reqbj.price = li?.mrpPrice;
      //   reqbj.total = Number(
      //     Number(li?.mrpPrice ?? 0) * Number(li?.returnQuantity ?? 0),
      //   );
      // }
      if (li?.uomName) reqbj.uomName = li?.uomName;
      if (li?.uomId) reqbj.uomId = li?.uomId;
      if (li?.serviceId) reqbj.serviceId = li?.serviceId;
      if (li?.stockId) reqbj.stockId = li?.stockId;
      if (li?.batchId) reqbj.batchId = li?.batchId;
      if (li?.paymentDetailId) reqbj.paymentDetailId = li?.paymentDetailId;
      // if (returnValue?.type !== "Return on Purchase") {
      //   reqbj.tax = li?.tax;
      //   reqbj.price = li?.price;
      //   reqbj.total = li?.total;
      // }
      // if (returnValue?.type === "Return on Purchase") {
      //   reqbj = {
      //     ...reqbj,
      //     ...(li ?? {}),
      //     returnQuantity: Number(li?.returnQuantity),
      //   };
      //   reqbj.tax = Number(li?.tax ?? 0 / li?.quantity ?? 0)?.toFixed(2);
      //   reqbj.price = li?.mrpPrice;
      //   reqbj.total = Number(
      //     Number(li?.mrpPrice ?? 0) * Number(li?.returnQuantity ?? 0),
      //   );
      // }
      // if (li?.serviceId) reqbj.serviceId = li?.serviceId;
      // if (li?.stockId) reqbj.stockId = li?.stockId;
      // if (li?.batchId) reqbj.batchId = li?.batchId;
      // if (li.paymentDetailId) reqbj.paymentDetailId = li.paymentDetailId;
      return reqbj;
    });
    const sumPaymentDetailsBy = (key) =>
      paymentDetails?.reduce((acc, obj) => acc + Number(obj?.[key] ?? 0), 0);
    const remainingItemsValue = (returnValue?.list ?? [])?.reduce((acc, li) => {
      const remainingQty = Math.max(
        0,
        Number(li?.quantity ?? 0) - Number(li?.returnQuantity ?? 0),
      );
      const unitPrice = isNaN(Number(Number(li?.total) / Number(li?.quantity)))
        ? 0
        : Number(Number(li?.total) / Number(li?.quantity));
      return acc + Number(unitPrice) * remainingQty;
    }, 0);
    const amountPaid = Number(
      selectedBill?.tab === "petShop"
        ? (selectedBill?.petShopAmtPaid ?? 0)
        : selectedBill?.tab === "pharmacy"
          ? (selectedBill?.pharmacyAmtPaid ?? 0)
          : (selectedBill?.amtPaid ?? 0),
    );
    const refundAmount = Math.max(
      0,
      amountPaid - Number(remainingItemsValue ?? 0),
    );
    const data = {
      paymentDetails,
      creditSave: status,
      remarks: returnValue?.remarks ?? "",
      paymentMode: returnValue?.refundMethod?.value,
      personInCharge: returnValue?.personInCharge?.value ?? null,
      returnReason: returnValue?.returnReason?.value,
      invoiceNumbers: returnValue?.invoiceNumber?.value,
      refundAmount: -Number(refundAmount),
      totalAmt: -Number(sumPaymentDetailsBy("total") ?? 0),
      totalTax: -Number(sumPaymentDetailsBy("tax") ?? 0),
    };
    if (returnValue?.type !== "Return on Purchase") data.type = "sales";
    if (returnValue?.type === "Return on Purchase") data.type = "purchase";
    dispatch(
      updateReturnOnBillingItems({
        data,
        id:
          returnValue?.type === "Return on Purchase"
            ? returnValue?.invoiceNumber?.detailId
            : (selectedBill?.paymentId ??
              returnValue?.invoiceNumber?.paymentId ??
              returnValue?.invoiceNumber?.detailId),
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseRetMod("apiSuccess");
      }
    });
  };

  const handleChangeTblValue = (name, value, ind) => {
    const reqList = returnValue?.list?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "returnQuantity") {
          reqObj.returnQuantityErr =
            Number(li?.quantity) < Number(value) ? "Maximum limit reached" : "";
        }
        return reqObj;
      }
      return li;
    });
    if (listNotValid) {
      if (reqList?.some((li) => Number(li?.returnQuantity) > 0)) {
        setListNotValid(false);
      }
    }
    const reqValue = { ...returnValue, list: reqList };
    setReturnValue(reqValue);
  };

  const handleChange = (name, value) => {
    setReturnValue({ ...returnValue, [name]: value });
  };

  const getPersonInChargeList = () => {
    return (clinicVets ?? [])
      ?.filter(
        (li) =>
          li?.userRole === "ROLE_CLINICADMIN" ||
          li?.userRole === "ROLE_BILLING",
      )
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
  };

  return (
    <>
      <CustomModal
        open={modVsble}
        onClose={() => onCloseRetMod("close")}
        header={headerName}
        modalWidth={30}
        rightModal
      >
        <div className="scroll-90vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Type <span className="red-color">*</span>
              </div>
              <CustomSelect
                list={ReturnAdjustList}
                handleChange={(e, value) => onChangeModValue("type", value)}
                value={modValues?.type}
                helperText={modErrors?.type}
                error={!!modErrors?.type}
                search
              />
            </Grid>
            {modValues?.type?.value ? (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <CustomTextField
                    fullWidth
                    search
                    value={modValues?.searchValue}
                    placeholder={`Search ${modValues?.type?.value === "Return on Purchase" ? "Supplier" : "Customer"}`}
                    handleChange={(e) =>
                      onChangeModValue("searchValue", e?.target?.value)
                    }
                    backgroundColor={AppColors.gray6}
                  />
                </Grid>
                {modValues?.searchValue?.length > 0 ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      {modValues?.type?.value === "Return on Purchase" &&
                        getFilteredSupplierList()?.length > 0 &&
                        getFilteredSupplierList()?.map((sup) => {
                          return (
                            <Grid
                              container
                              spacing={1}
                              key={sup?.supplierId}
                              className="cursor"
                              onClick={() => handleSelectedSupplier(sup)}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Grid container spacing={1}>
                                  <Grid item xs={12}>
                                    <Card
                                      sx={{
                                        borderRadius: 1,
                                        padding: 2,
                                        borderTopColor: AppColors.appPrimary,
                                      }}
                                      className="CustomCard-back-appointment"
                                    >
                                      <div className="maint">
                                        <div className="flex-row">
                                          <Grid item>
                                            <div className="flex-row">
                                              <div className="flex-start">
                                                <div className="flex-column">
                                                  <div className="flex-row">
                                                    <Typography className="mb10 font-bold fs14 capitalize">
                                                      {sup?.supplierName}
                                                    </Typography>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </Grid>
                                        </div>
                                      </div>
                                    </Card>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          );
                        })}
                      {modValues?.type?.value === "Return on Sales" &&
                        getFilteredUserList()?.length > 0 &&
                        getFilteredUserList()?.map((usr) => {
                          return (
                            <Grid
                              container
                              spacing={1}
                              key={usr?.id}
                              className="cursor"
                              onClick={() => handleSelectedUser(usr)}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <Grid container spacing={1}>
                                  <Grid item xs={12}>
                                    <Card
                                      sx={{
                                        borderRadius: 1,
                                        padding: 2,
                                        borderTopColor: AppColors.appPrimary,
                                      }}
                                      className="CustomCard-back-appointment"
                                    >
                                      <div className="maint">
                                        <div className="flex-row">
                                          <Grid item>
                                            <div className="flex-row">
                                              <div className="flex-start">
                                                <div className="flex-column">
                                                  <div className="flex-row">
                                                    <Typography className="mb10 font-bold fs14 capitalize">
                                                      {usr?.name}
                                                    </Typography>
                                                  </div>
                                                  <Typography className="mb10 txt-regular card-gray-color fs12">
                                                    {usr?.email}
                                                  </Typography>
                                                  <Typography className="mb10 txt-regular card-gray-color fs12">
                                                    {usr?.mobile}
                                                  </Typography>
                                                </div>
                                              </div>
                                            </div>
                                          </Grid>
                                        </div>
                                      </div>
                                    </Card>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          );
                        })}
                    </Grid>
                  </>
                ) : null}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="txt-semi-bold fs14 light-grey">
                    {modValues?.type?.value === "Return on Sales"
                      ? "Customer"
                      : "Supplier"}{" "}
                    <span className="red-color">*</span>
                  </div>
                  <CustomSelect
                    list={[]}
                    value={
                      modValues?.type?.value === "Return on Sales"
                        ? modValues?.customer
                        : modValues?.supplier
                    }
                    helperText={
                      modValues?.type?.value === "Return on Sales"
                        ? modErrors?.customer
                        : modErrors?.supplier
                    }
                    error={
                      modValues?.type?.value === "Return on Sales"
                        ? !!modErrors?.customer
                        : !!modErrors?.supplier
                    }
                    search
                    disabled
                  />
                </Grid>
                {modValues?.customer?.value || modValues?.supplier?.value ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="txt-semi-bold fs14 light-grey">
                      Invoice Number <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={
                        modValues?.type?.value === "Return on Purchase"
                          ? getSupInvoiceList()
                          : getInvoiceList()
                      }
                      handleChange={(e, value) =>
                        onChangeModValue("invoiceNumber", value)
                      }
                      value={modValues?.invoiceNumber}
                      helperText={modErrors?.invoiceNumber}
                      error={!!modErrors?.invoiceNumber}
                      search
                    />
                  </Grid>
                ) : null}
              </>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end mt10">
                <div>
                  <CustomButton text="Submit" smallBtn onClick={handleSubmit} />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={updateModVsble}
        onClose={() => onCloseRetMod("close")}
        header={returnValue?.type}
        modal
        modalWidth={90}
      >
        <div className="scroll-80vh">
          <div className="return-back">
            <div className="flex-row-ali-cen ph40 mv15">
              <div className="w25Per">
                <Typography className="gray29 fs12 font-medium">
                  {returnValue?.type === "Return on Purchase"
                    ? "Supplier"
                    : "Pet"}{" "}
                  Name
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {(returnValue?.type === "Return on Purchase"
                    ? selectedBill?.supplierName
                    : selectedBill?.petName) ?? ""}
                </Typography>
              </div>
              <div className="w25Per">
                <Typography className="gray29 fs12 font-medium">
                  {returnValue?.type === "Return on Purchase"
                    ? "Supplier GST No."
                    : "Parent Name"}
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {(returnValue?.type === "Return on Purchase"
                    ? (selectedBill?.gstNumber ?? "")
                    : selectedBill?.userName) ?? ""}
                </Typography>
              </div>
              <div className="w25Per">
                <Typography className="gray29 fs12 font-medium">
                  Invoice number
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {selectedBill?.invoiceNumbers ?? ""}
                </Typography>
              </div>
              <div className="w25Per">
                <Typography className="gray29 fs12 font-medium">
                  Invoice date
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {moment(new Date(selectedBill?.createdDate)).format(
                    "DD MMM YYYY",
                  )}
                </Typography>
              </div>
            </div>
          </div>

          <div className="flex-row-ali-cen mt20 ph10">
            <div className={"w25Per"}>
              <Typography className="txt-semi-bold fs12 blue-color">
                Service/Item Name
              </Typography>
            </div>
            <div className={"w15Per"}>
              <Typography className="txt-semi-bold fs12 blue-color">
                Available Qty
              </Typography>
            </div>
            <div className={"w15Per"}>
              <Typography className="txt-semi-bold fs12 blue-color">
                Returning Qty
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Unit Price
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Refundable Taxes
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Refund Total
              </Typography>
            </div>
          </div>
          <div className="blue-hor-split mt5" />
          {returnValue?.list?.map((li, i) => {
            const taxVal = Number(li?.tax) / Number(li?.quantity);

            return (
              <div className="plan-bor mt10 flex-row-ali-cen" key={`${i} li`}>
                <div className="w25Per pr10">
                  <Custom3dotString
                    className="txt-regular fs12 gray30"
                    str={li?.name}
                    length={25}
                  />
                </div>

                <div className="w15Per pr10">
                  <Typography className="txt-regular fs12 gray30">
                    {li?.quantity} Nos
                  </Typography>
                </div>
                <div className="w15Per pr10">
                  <CustomTextField
                    value={li?.returnQuantity}
                    error={!!li?.returnQuantityErr}
                    helperText={li?.returnQuantityErr}
                    fullWidth
                    endIcon
                    inputIcon="Nos"
                    handleChange={(e) =>
                      handleChangeTblValue(
                        "returnQuantity",
                        e?.target?.value,
                        i,
                      )
                    }
                  />
                </div>
                <div className="w15Per pr10">
                  <Typography className="txt-regular fs12 gray30">
                    Rs {Number(li?.mrpPrice)?.toFixed(2)}{" "}
                  </Typography>
                </div>
                <div className="w15Per pr10">
                  <Typography className="txt-regular fs12 gray30">
                    Rs {Number(taxVal) > 0 ? Number(taxVal)?.toFixed(2) : 0}
                  </Typography>
                </div>
                <div className="w15Per">
                  <Typography className="txt-regular fs12 gray30">
                    Rs{" "}
                    {Number(
                      Number(li?.returnQuantity ?? 0) *
                        Number(li?.mrpPrice ?? 0),
                    )?.toFixed(2)}{" "}
                  </Typography>
                </div>
              </div>
            );
          })}
          {listNotValid ? (
            <FormHelperText error className="flex-center mt10">
              Enter quantity for atleast one item
            </FormHelperText>
          ) : null}
          <div className="flex-row mt30">
            <div className="w30Per">
              <div className="flex-column">
                <div>
                  <CustomSelect
                    list={returnReasons}
                    value={returnValue?.returnReason}
                    handleChange={(e, value) =>
                      handleChange("returnReason", value)
                    }
                    search
                    fullWidth
                    label="Return Reason"
                    name="returnReason"
                  />
                  <div className="mt10">
                    <CustomSelect
                      list={getPersonInChargeList()}
                      value={returnValue?.personInCharge ?? null}
                      handleChange={(e, value) => {
                        handleChange("personInCharge", value);
                      }}
                      search
                      fullWidth
                      label="Person In charge"
                      name="personInCharge"
                    />
                  </div>
                  <div className="mt10">
                    <PaymentModeDropdown
                      list={RefundTypes}
                      value={returnValue?.refundMethod}
                      onChange={(e, value) => handleChange("refundMethod", e)}
                      name="refundMethod"
                      label="Refund Method"
                    />
                  </div>
                </div>
                <div className="mt10">
                  <CustomTextField
                    value={returnValue?.remarks}
                    handleChange={(e) =>
                      handleChange("remarks", e?.target?.value)
                    }
                    fullWidth
                    label="Remarks"
                    labelTop
                    name="remarks"
                    multiline
                  />
                </div>
              </div>
            </div>
            <div className="flex1-end">
              <div className="w50Per">
                <div className="flex-column">
                  <div className="flex-row-ali-cen">
                    <div className="w60Per">
                      <Typography className="black23 font-medium fs14">
                        Refund Subtotal
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="black23 font-medium fs14">
                        Rs.{" "}
                        {Number(
                          returnValue?.type === "Return on Purchase"
                            ? getRefundValues(returnValue?.list)?.subTotal -
                                getRefundValues(returnValue?.list)?.tax
                            : getRefundValues(returnValue?.list)?.subTotal,
                        )?.toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="w60Per">
                      <Typography className="black23 font-medium fs14">
                        Refundable Taxes
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="black23 font-medium fs14">
                        Rs.{" "}
                        {Number(getRefundValues(returnValue?.list)?.tax) > 0
                          ? Number(
                              getRefundValues(returnValue?.list)?.tax,
                            )?.toFixed(2)
                          : 0}
                      </Typography>
                    </div>
                  </div>

                  <div className="flex-row-ali-cen ref-ttl mt30">
                    <div className="w60Per">
                      <Typography className="blue-color txt-semi-bold fs14">
                        Refund Total
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="blue-color font-bold fs14">
                        Rs.{" "}
                        {Number(
                          returnValue?.type === "Return on Purchase"
                            ? getRefundValues(returnValue?.list)?.subTotal
                            : getRefundValues(returnValue?.list)?.total,
                        )?.toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Save As Draft"
                smallBtn
                onClick={() => submitReturn("draft")}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="Submit"
                smallBtn
                onClick={() => submitReturn("credit")}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PaymentReturn;
